<template>
  <v-row>
    <v-col cols="12">
      <v-alert type="warning" text outlined>
        Wajib untuk klik simpan setelah mengisi data pengaturan
      </v-alert>
    </v-col>
    <!-- Tampilkan pembahasan -->
    <v-col cols="12" class="pt-0">
      <div class="font-weight-medium mb-2">
        <span> Tampilkan Pembahasan </span>
      </div>
      <v-radio-group
        v-model.number="data.is_show_discussion"
        @change="changeShowDiscussion(data)"
      >
        <v-radio :value="1">
          <span slot="label" class="color--text">Ya</span>
        </v-radio>
        <v-radio :value="0">
          <span slot="label" class="color--text">Tidak</span>
        </v-radio>
      </v-radio-group>
    </v-col>
    <!-- Tampilkan correct answer -->
    <v-col v-show="data.is_show_discussion == true" cols="12">
      <div class="font-weight-medium mb-2">
        <span> Tampilkan Koreksi Jawaban </span>
      </div>
      <v-radio-group v-model.number="data.is_show_answer">
        <v-radio :value="1">
          <span slot="label" class="color--text">Ya</span>
        </v-radio>
        <v-radio :value="0">
          <span slot="label" class="color--text">Tidak</span>
        </v-radio>
      </v-radio-group>
    </v-col>
    <!-- Konfigurasi nilai minimal -->
    <v-col cols="12">
      <div class="font-weight-medium mb-2">
        <span> Atur Nilai Minimal </span>
      </div>
      <v-radio-group v-model="set_minimum_value.is_set">
        <v-radio :value="1">
          <span slot="label" class="color--text">Ya</span>
        </v-radio>
        <v-radio :value="0">
          <span slot="label" class="color--text">Tidak</span>
        </v-radio>
      </v-radio-group>
    </v-col>
    <!-- Nilai minimal -->
    <v-expand-transition>
      <v-col v-if="set_minimum_value.is_set != '0'" cols="12">
        <div class="font-weight-medium mb-2">
          <span> Nilai Minimal </span>
        </div>
        <v-text-field
          v-model="set_minimum_value.minimum_value"
          placeholder="Masukkan nilai minimal"
        ></v-text-field>
      </v-col>
    </v-expand-transition>
    <!--  <v-col cols="12">
      <div class="font-weight-medium mb-2">
        <span> Atur Penilaian Otomatis </span>
      </div>
      <v-radio-group>
        <v-radio>
          <span slot="label" class="color--text">Ya</span>
        </v-radio>
        <v-radio>
          <span slot="label" class="color--text">Tidak</span>
        </v-radio>
      </v-radio-group>
    </v-col> -->
    <!-- Mengulang -->
    <v-col cols="12">
      <div class="font-weight-medium mb-2">
        <span> Kesempatan Mengulang </span>
      </div>
      <v-select
        v-model.number="data.opportunity_repeat_test"
        :items="tries"
        item-value="val"
        placeholder="Pilih kesempatan mengulang"
      ></v-select>
    </v-col>
    <!-- Skip -->
    <v-col cols="12">
      <div class="font-weight-medium mb-2">
        <span> Skip </span>
      </div>
      <v-radio-group v-model.number="data.is_skip">
        <v-radio :value="1">
          <span slot="label" class="color--text">Ya</span>
        </v-radio>
        <v-radio :value="0">
          <span slot="label" class="color--text">Tidak</span>
        </v-radio>
      </v-radio-group>
    </v-col>
    <!-- Tampilkan timer -->
    <v-col cols="12">
      <div class="font-weight-medium mb-2">
        <span> Tampilkan Timer </span>
      </div>
      <v-radio-group v-model.number="data.is_show_timer">
        <v-radio :value="1">
          <span slot="label" class="color--text">Ya</span>
        </v-radio>
        <v-radio :value="0">
          <span slot="label" class="color--text">Tidak</span>
        </v-radio>
      </v-radio-group>
    </v-col>
    <!-- Tampilkan score -->
    <v-col cols="12">
      <div class="font-weight-medium mb-2">
        <span> Tampilkan Score </span>
      </div>
      <v-radio-group v-model.number="data.is_show_score">
        <v-radio :value="1">
          <span slot="label" class="color--text">Ya</span>
        </v-radio>
        <v-radio :value="0">
          <span slot="label" class="color--text">Tidak</span>
        </v-radio>
      </v-radio-group>
    </v-col>
    <!-- Konfig acak urutan soal -->
    <v-col cols="12">
      <v-checkbox
        v-model.number="data.is_random_question"
        :true-value="1"
        :false-value="0"
      >
        <span slot="label" class="color--text"
          >Acak urutan soal / grup soal</span
        >
      </v-checkbox>
    </v-col>
    <!-- Jumlah soal -->
    <v-col cols="12">
      <div class="font-weight-medium mb-2">
        <span> Jumlah Soal per Paket </span>
      </div>
      <v-text-field
        v-model.number="data.number_questions_package"
        type="number"
        placeholder="Masukkan jumlah soal per paket"
      ></v-text-field>
    </v-col>
    <!-- Konfig acak soal per paket -->
    <!-- <v-col cols="12">
      <v-checkbox>
        <span slot="label" class="color--text">Acak soal per paket</span>
      </v-checkbox>
    </v-col> -->
    <!-- Estianti -->
    <v-col cols="12">
      <v-row>
        <v-col cols="12" md="6">
          <div class="font-weight-medium mb-2">
            <span> Estimasi Durasi (Menit) </span>
          </div>
          <v-row>
            <v-col class="pt-0">
              <v-text-field
                v-model="data.estimated_duration"
                type="number"
                min="0"
                placeholder="00"
              ></v-text-field>
              <!-- <div class="text--secondary mt-2">Jam</div> -->
            </v-col>
            <!-- <v-col class="pt-0">
              <v-text-field type="number" min="0" max="59" placeholder="00"></v-text-field>
              <div class="text--secondary mt-2">Menit</div>
            </v-col>
            <v-col class="pt-0">
              <v-text-field type="number" min="0" max="59" placeholder="00"></v-text-field>
              <div class="text--secondary mt-2">Detik</div>
            </v-col> -->
          </v-row>
        </v-col>
        <!-- Waktu Ujian -->
        <v-col cols="12" md="6">
          <div class="font-weight-medium mb-2">
            <span> Waktu Ujian (Menit)</span>
          </div>
          <v-text-field
            v-model="data.timer"
            type="number"
            min="0"
            placeholder="00"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-col>

    <!-- Anti curang -->
    <v-col cols="12">
      <v-row>
        <v-col cols="12"><v-divider /></v-col>

        <v-col cols="12" sm="6">
          <div class="d-flex align-center">
            <div style="margin-right: 10px; font-weight: 500; font-size: 16px">
              Capture Wajah
            </div>
            <div
              v-if="data.face_capture"
              style="color: #f05326; font-size: 12px"
            >
              Mode Aktif
            </div>
            <div v-else style="color: #8492a6; font-size: 12px">Non aktif</div>
          </div>
          <div>Pengaturan capture wajah pada awal & akhir aktivitas</div>
        </v-col>
        <v-col cols="12" sm="6">
          <v-switch v-model="data.face_capture" inset> </v-switch>
        </v-col>

        <v-col cols="12"><v-divider /></v-col>

        <v-col cols="12">
          <div class="font-weight-medium mb-2">Pengaturan kecurangan</div>
        </v-col>

        <v-col cols="12" sm="6">
          <div class="d-flex align-center">
            <div style="margin-right: 10px; font-weight: 500; font-size: 16px">
              Open Tab
            </div>
            <div
              v-if="collect_data.open_new_tab"
              style="color: #f05326; font-size: 12px"
            >
              Mode Aktif
            </div>
            <div v-else style="color: #8492a6; font-size: 12px">Non aktif</div>
          </div>
          <div>Pengaturan indentifikasi open tab peserta</div>
        </v-col>

        <v-col cols="12" sm="6">
          <v-switch v-model="collect_data.open_new_tab" inset> </v-switch>
        </v-col>

        <v-col cols="12" sm="6">
          <div class="d-flex align-center">
            <div style="margin-right: 10px; font-weight: 500; font-size: 16px">
              Deteksi wajah ganda
            </div>
            <div
              v-if="collect_data.multi_face_detection"
              style="color: #f05326; font-size: 12px"
            >
              Mode Aktif
            </div>
            <div v-else style="color: #8492a6; font-size: 12px">Non aktif</div>
          </div>
          <div>Pengaturan identifikasi wajah peserta test</div>
        </v-col>

        <v-col cols="12" sm="6">
          <v-switch v-model="collect_data.multi_face_detection" inset>
          </v-switch>
        </v-col>

        <v-col cols="12" sm="6">
          <div class="d-flex align-center">
            <div style="margin-right: 10px; font-weight: 500; font-size: 16px">
              Suara
            </div>
            <div
              v-if="collect_data.chat_detection"
              style="color: #f05326; font-size: 12px"
            >
              Mode Aktif
            </div>
            <div v-else style="color: #8492a6; font-size: 12px">Non aktif</div>
          </div>
          <div>Pengaturan Identifikasi suara percakapan</div>
        </v-col>

        <v-col cols="12" sm="6">
          <v-switch v-model="collect_data.chat_detection" inset> </v-switch>
        </v-col>

        <!-- FITUR GUGUR TEST -->
        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>

        <v-col cols="12"> Pengaturan Sistem Gugur untuk Peserta </v-col>

        <v-col cols="12" sm="6">
          <div class="d-flex align-center">
            <div style="margin-right: 10px; font-weight: 500; font-size: 16px">
              Sistem gugur open tab
            </div>
            <div
              v-if="disqualification.open_new_tab.enabled"
              style="color: #f05326; font-size: 12px"
            >
              Mode Aktif
            </div>
            <div v-else style="color: #8492a6; font-size: 12px">Non aktif</div>
          </div>
          <div>Pengaturan sistem gugur open tab untuk peserta</div>
        </v-col>

        <v-col cols="12" sm="6">
          <v-switch
            :disabled="!collect_data.open_new_tab"
            v-model="disqualification.open_new_tab.enabled"
            inset
          >
          </v-switch>
        </v-col>

        <v-col cols="12" sm="6">
          <div class="d-flex align-center">
            <div style="margin-right: 10px; font-weight: 500; font-size: 16px">
              Sistem gugur deteksi wajah
            </div>
            <div
              v-if="disqualification.multi_face_detection.enabled"
              style="color: #f05326; font-size: 12px"
            >
              Mode Aktif
            </div>
            <div v-else style="color: #8492a6; font-size: 12px">Non aktif</div>
          </div>
          <div>Pengaturan sistem gugur deteksi wajah peserta</div>
        </v-col>

        <v-col cols="12" sm="6">
          <v-switch
            v-model="disqualification.multi_face_detection.enabled"
            :disabled="!collect_data.multi_face_detection"
            inset
          >
          </v-switch>
        </v-col>

        <v-col cols="12" sm="6">
          <div class="d-flex align-center">
            <div style="margin-right: 10px; font-weight: 500; font-size: 16px">
              Sistem Gugur Suara
            </div>
            <div
              v-if="disqualification.chat_detection.enabled"
              style="color: #f05326; font-size: 12px"
            >
              Mode Aktif
            </div>
            <div v-else style="color: #8492a6; font-size: 12px">Non aktif</div>
          </div>
          <div>Pengaturan sistem gugur suara peserta</div>
        </v-col>

        <v-col cols="12" sm="6">
          <v-switch
            :disabled="!collect_data.chat_detection"
            v-model="disqualification.chat_detection.enabled"
            inset
          >
          </v-switch>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import model from "../_mixins/model";

export default {
  mixins: [model],
  data() {
    return {
      nilaiOpsi: null,
      nilai: "",

      set_minimum_value: {},
      collect_data: {
        multi_face_detection: false,
        open_new_tab: false,
        chat_detection: false,
      },
      disqualification: {
        multi_face_detection: {
          enabled: false,
          max_violation: 3,
        },
        open_new_tab: {
          enabled: false,
          max_violation: 3,
        },
        chat_detection: {
          enabled: false,
          max_violation: 3,
        },
      },
      setting: {
        identification: {
          face: true,
          voice: true,
          new_tab: true,
        },
        failed: {
          face: true,
          voice: true,
          new_tab: true,
        },
      },
    };
  },
  computed: {
    tries() {
      return [
        { val: 1, text: "1 x" },
        { val: 10, text: "10 x" },
        { val: 50, text: "50 x" },
        { val: 100, text: "100 x" },
        { val: 0, text: "Tanpa mengulang" },
        { val: -1, text: "Mengulang tanpa batas" },
      ];
    },

    // set_minimum_value() {
    //   return this.data?.set_minimum_value || {};
    // },
  },
  watch: {
    set_minimum_value: {
      handler(val) {
        this.$set(this.data, "set_minimum_value", val);
        // this.data.set_minimum_value = val;
      },
      deep: true,
    },
    collect_data: {
      handler(val) {
        if (!val.open_new_tab)
          this.disqualification.open_new_tab.enabled = false;
        if (!val.multi_face_detection)
          this.disqualification.multi_face_detection.enabled = false;
        if (!val.chat_detection)
          this.disqualification.chat_detection.enabled = false;

        this.$set(this.data, "collect_data", val);
      },
      deep: true,
    },
    disqualification: {
      handler(val) {
        this.$set(this.data, "disqualification", val);
      },
      deep: true,
    },
  },
  created() {
    this.$set(this.data, "is_random_question", this.data.is_random_question);
    this.$set(
      this.set_minimum_value,
      "is_set",
      this.data.set_minimum_value?.is_set
    );
    this.$set(
      this.set_minimum_value,
      "minimum_value",
      this.data.set_minimum_value?.minimum_value
    );
    if (this.data.disqualification)
      this.disqualification = this.data.disqualification;
    if (this.data.collect_data) this.collect_data = this.data.collect_data;
    // console.log(this.data)
  },
  methods: {
    changeShowDiscussion(data) {
      if (
        data.is_show_discussion === 1 ||
        data.is_show_discussion === "1" ||
        data.is_show_discussion === true
      ) {
        this.$set(this.data, "is_show_answer", "");
      } else {
        this.$set(this.data, "is_show_answer", 0);
      }
    },
  },
};
</script>
<style>
#ck .v-label {
  color: #4c6583;
}
#ck .v-input--checkbox .v-icon {
  color: #4c6583;
}
</style>
